import {
  FolderIcon,
  ClockIcon,
  CheckCircleIcon,
} from "@heroicons/react/24/solid";
import type { ProjectsStatsProps } from "./projectsStats.types";

export function ProjectsStats({ stats, isLoading }: ProjectsStatsProps) {
  if (isLoading || !stats) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      <div className="bg-white rounded-xl p-6 border border-primary-100 shadow-raro">
        <div className="flex items-center">
          <div className="flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg">
            <FolderIcon className="w-6 h-6 text-primary-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-raro-gray-600">Total</p>
            <p className="text-2xl font-bold text-raro-gray-900 font-montserrat">
              {stats.total}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 border border-primary-100 shadow-raro">
        <div className="flex items-center">
          <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-lg">
            <ClockIcon className="w-6 h-6 text-blue-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-raro-gray-600">
              Em Andamento
            </p>
            <p className="text-2xl font-bold text-raro-gray-900 font-montserrat">
              {stats.byStatus.in_progress}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 border border-primary-100 shadow-raro">
        <div className="flex items-center">
          <div className="flex items-center justify-center w-12 h-12 bg-green-100 rounded-lg">
            <CheckCircleIcon className="w-6 h-6 text-green-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-raro-gray-600">
              Concluídos
            </p>
            <p className="text-2xl font-bold text-raro-gray-900 font-montserrat">
              {stats.byStatus.completed}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 border border-primary-100 shadow-raro">
        <div className="flex items-center">
          <div className="flex items-center justify-center w-12 h-12 bg-amber-100 rounded-lg">
            <ClockIcon className="w-6 h-6 text-amber-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-raro-gray-600">
              Rascunhos
            </p>
            <p className="text-2xl font-bold text-raro-gray-900 font-montserrat">
              {stats.byStatus.draft}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}